import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { UserPlus, ArrowRight } from 'lucide-react';
import '../../../assets/styles/customer/layout/BecomeDistributorSection.css';
import MyButton from '../../../components/common/Button/MyButton';

const BecomeDistributorSection = () => {
  return (
    <section className="become-distributor-section">
      
      {/* Floating Background */}
      <div className="become-dist-floating">
        <div className="become-circle circle-1"></div>
        <div className="become-circle circle-2"></div>
      </div>

      {/* Wave Pattern */}
      <div className="become-dist-pattern">
        <div className="pattern-dot"></div>
        <div className="pattern-dot"></div>
        <div className="pattern-dot"></div>
        <div className="pattern-dot"></div>
      </div>

      <Container>
        <Row className="justify-content-center">
          <Col lg={10} xl={8}>
            
            <div className="become-dist-content text-center">
              
              <h2 className="become-dist-title">
                Are You a Milk Distributor?
              </h2>

              <p className="become-dist-description">
                Join our platform and reach thousands of customers looking for quality milk 
                delivery services.
              </p>

              <MyButton variant="primary" className="register-dist-btn">
                <UserPlus size={20} className="me-2" />
                Register as Distributor
                <ArrowRight size={20} className="ms-2" />
              </MyButton>

            </div>

          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default BecomeDistributorSection;